module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-sh.517a52d0.png";